import React from 'react';
import AutoComplete from 'material-ui/AutoComplete';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { updateTcOrder } from 'actions/tc/orders';
import _ from 'lodash';
import { MenuItem } from 'material-ui';

const defaultDuration = [
    { text: 'ABT', value: (<MenuItem primaryText="ABT" /> ) },
    { text: 'AGW', value: (<MenuItem primaryText="AGW" /> ) },
    { text: 'WP', value: (<MenuItem primaryText="WP" /> ) },
    { text: 'WOG', value: (<MenuItem primaryText="WOG" /> ) },
    { text: 'AGW WP', value: (<MenuItem primaryText="AGW WP" /> ) },
    { text: 'AGW WP WOG', value: (<MenuItem primaryText="AGW WP WOG" /> ) },
    { text: 'AGW WOG', value: (<MenuItem primaryText="AGW WOG" /> ) },
    { text: 'WP WOG', value: (<MenuItem primaryText="WP WOG" /> ) },
    { text: 'ABT AGW WP', value: (<MenuItem primaryText="ABT AGW WP" /> ) },
    { text: 'ABT AGW WP WOG', value: (<MenuItem primaryText="ABT AGW WP WOG" /> ) },
    { text: 'ABT WP WOG', value: (<MenuItem primaryText="ABT WP WOG" /> ) },
  ];

class TCDuration extends React.PureComponent {

    changeAutoComplete = searchText => {
        const _tcOrder = _.cloneDeep(this.props.tcOrder);

        _tcOrder.tcDuration = searchText;

        this.props.updateTcOrder(this.props.numberOrderTable, _tcOrder);
    }

    render() {
        const { tcDuration } = this.props.tcOrder;

        return (
            <div className='row'>
                <div className='col-xs-6'>
                    <AutoComplete
                        floatingLabelText={'T/C Duration'}
                        textFieldStyle={{ fontSize: '13px' }}
                        hintText={'T/C Duration'}
                        searchText={tcDuration || ''}
                        dataSource={defaultDuration}
                        onUpdateInput={this.changeAutoComplete}
                        filter={AutoComplete.noFilter}
                        listStyle={{ overflow: 'auto', maxHeight: '300px', width: 'auto' }}
                        menuStyle={{ width: 'auto' }}
                        popoverProps={{
                            canAutoPosition: true,
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default connect(
    () => {
        return {
            // tcOrders,
        };
    },
    dispatch => bindActionCreators({
        updateTcOrder,
    }, dispatch),
)(TCDuration);




// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/TC/content/TCDuration.jsx